import $ from 'jquery';
export default {

    data() {
        return {
            navOpen: false,
            windowWidth: 0,
        }
    },

    watch: {
        navOpen() {
            $('body').toggleClass('nav-open');
        },
    },

    methods: {
        toggleResponsiveNav() {

            /** Reset responsive menu position before close */
            if (this.navOpen) {
                document.getElementById('responsive-nav').style.top = 0 + 'px';
            }

            /** Toggle */
            this.navOpen = !this.navOpen;

            let header = document.getElementById('global-header');
            let navigation = document.getElementById('site-navigation');
            let header_height = header.clientHeight;
            let navigation_height = navigation.clientHeight;

            /** Set responsive menu position */
            this.$nextTick(() => {
                let responsive_nav = document.getElementById('responsive-nav');
                responsive_nav.style.top = header_height + navigation_height + 'px';
            });
        },
        displayDropMenu(event) {

            let target_item = event.target.parentElement.parentElement;
            let target_children_menu = event.target.parentElement.parentElement.getElementsByClassName('responsive__nav-children')[0];
            let children_menus = document.getElementsByClassName('responsive__nav-children');

            /** Reset/close responsive navigation dropdowns */
            Array.from(children_menus).forEach(function (e) {
                if (e !== target_children_menu) {
                    e.classList.remove("--show");
                }
            });

            /** Reset responsive navigation items' margins */
            let items = document.getElementsByClassName("responsive__nav-item");
            Array.from(items).forEach(function (e) {
                e.style.marginTop = 0;
            });

            /** Toggle item dropdown show/hide */
            (! target_children_menu.classList.contains("--show"))
                ? target_children_menu.classList.add("--show")
                : target_children_menu.classList.remove("--show");

            /** Add margin to the sibling element - margin = height of the sibling dropdown */
            if (target_children_menu.classList.contains("--show"))
                target_item.nextSibling.nextSibling.style.marginTop = target_children_menu.clientHeight + 20 + "px";
        }
    }
}
